module.exports = __webpack_public_path__ + "img/cert2x.5bd5b43d.jpg";